import React from "react";
import { GrayBorderBox } from "../../../../styles/boxes";
import { AlignedBoxSubTitle, AlignedBoxTitle } from "../../../../styles/texts";
import { GrayButton } from "../../../../styles/buttons";

interface PreInstallationBoxProps {
  currentStage: string;
  title: string;
  date: string;
  description: string;
  buttonText: string;
  buttonIcon?: string;
  onButtonClick: () => void;
}

const PreInstallationBox: React.FC<PreInstallationBoxProps> = ({
  currentStage,
  title,
  date,
  description,
  buttonText,
  buttonIcon = "rightarrow",
  onButtonClick,
}) => {
  return (
    <GrayBorderBox w="100%" h="auto" p="24px" m="16px">
      {/* Título y subtítulo */}
      <div className="flex flex-col items-start">
        <AlignedBoxSubTitle fontSize="14px">{currentStage}</AlignedBoxSubTitle>
        <AlignedBoxTitle fontSize="18px">{title}</AlignedBoxTitle>
        <AlignedBoxSubTitle fontSize="14px">{date}</AlignedBoxSubTitle>
      </div>

      {/* Descripción */}
      <div
        style={{
          marginTop: "16px",
          color: "#6D707E",
          fontSize: "14px",
          lineHeight: "20px",
          fontFamily: "Montserrat",
        }}
      >
        {description}
      </div>

      {/* Botón <div className="flex justify-end mt-6">*/}
      
      <div className="mt-6 w-full text-left flex flex-col items-end">
        <GrayButton
          label={buttonText}
          icon={buttonIcon}
          w="250px"
          onClick={onButtonClick}
        />
      </div>
    </GrayBorderBox>
  );
};

export default PreInstallationBox;
